// Community Page Header - Shared header for all community pages
// Community, Browse, Discord all on the left
// Admin button (when admin on normal path) / Back button (when on admin path) - mimics Marketplace
// When isSupporter=false, nav buttons are disabled (no navigation)

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import './CommunityPageHeader.css';

export function CommunityPageHeader({ isSupporter = true }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const path = location.pathname;
  const isAdminPath = path.includes('/community/admin/');

  const getActiveSection = () => {
    if (path.includes('/browse')) return 'browse';
    if (path.includes('/discord')) return 'discord';
    return 'main';
  };

  const activeSection = getActiveSection();

  const handleNavigation = (section) => {
    if (!isSupporter) return;
    if (section === 'main' || section === 'browse') {
      navigate('/community/browse');
    } else {
      navigate(`/community/${section}`);
    }
  };

  // Admin: navigate to admin version of current page; Back: navigate to normal version
  const handleAdminClick = () => {
    if (!isSupporter || user?.role !== 'admin') return;
    if (isAdminPath) {
      const base = path.includes('/discord') ? '/community/discord' : '/community/browse';
      navigate(base);
    } else {
      const base = path.includes('/discord') ? '/community/admin/discord' : '/community/admin/browse';
      navigate(base);
    }
  };

  const showAdminButton = user?.role === 'admin' && isSupporter;

  return (
    <div className="community-page-header">
      <div className="community-page-header-content">
        {/* Left side - Admin/Back button (admins only), Community, Browse, Discord */}
        <div className="community-page-header-left">
          {showAdminButton && (
            <button
              type="button"
              className={`community-admin-btn ${isAdminPath ? 'community-back-btn' : ''}`}
              onClick={handleAdminClick}
              title={isAdminPath ? 'Back to Community' : 'Community Admin'}
            >
              <i className={`fa-solid ${isAdminPath ? 'fa-arrow-left' : 'fa-cog'}`} aria-hidden />
              {isAdminPath ? 'Back' : 'Admin'}
            </button>
          )}
          <a
            href={isSupporter ? '/community/browse' : '#'}
            className={`community-logo-container ${activeSection === 'browse' ? 'active' : ''} ${!isSupporter ? 'is-disabled' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation('browse');
            }}
            aria-disabled={!isSupporter}
          >
            <span className="community-logo-text">Community</span>
          </a>
          <nav className="community-page-header-nav">
            <a
              href={isSupporter ? '/community/browse' : '#'}
              className={`header-nav-item ${activeSection === 'browse' ? 'active' : ''} ${!isSupporter ? 'is-disabled' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation('browse');
              }}
              aria-disabled={!isSupporter}
            >
              Browse
            </a>
            <a
              href={isSupporter ? '/community/discord' : '#'}
              className={`header-nav-item ${activeSection === 'discord' ? 'active' : ''} ${!isSupporter ? 'is-disabled' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation('discord');
              }}
              aria-disabled={!isSupporter}
            >
              Discord
            </a>
          </nav>
        </div>
      </div>
    </div>
  );
}
